<template>
  <div class="border-2 border-beige-academy-300 p-3 w-full
  flex justify-start mb-5">
    <vue-autosuggest
      class="w-full"
      v-model="query"
      :suggestions="filteredExperiences"
      @selected="$emit('selected', $event)"
      :input-props="{
        style: 'width: 100%; outline:none; border-bottom: 1px solid gray;',
        placeholder: 'Search...',
      }"
      :get-suggestion-value="getSuggestionValue"
      @input="$emit('input', query)"
    >
    <template slot-scope="{ suggestion }" class="w-full">
      <button
      class="pl-2 pr-4 py-2 w-84 bg-gray-100 text-left hover:bg-gray-200
      hover:font-semibold w-full text-md">
        {{ suggestion.item['company_name']}}, {{
          suggestion.item['city'] }}, {{ suggestion.item['country']}}
      </button>
    </template>
    </vue-autosuggest>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      query: '',
      experiences: [
        {
          data: [],
        },
      ],
    };
  },

  computed: {
    filteredExperiences() {
      return [
        {
          data: this.experiences[0].data.filter(
            (option) => option.company_name.toLowerCase().indexOf(this.query.toLowerCase()) > -1,
          ),
        },
      ];
    },
  },

  watch: {
    filteredExperiences() {
      if (this.filteredExperiences[0].data.length === 0) {
        this.$emit('empty');
      }
    },
  },

  created() {
    this.getExperiences();
  },

  methods: {
    getExperiences() {
      axios.get('/api/work-experiences').then(({ data }) => {
        this.experiences[0].data = data;
      });
    },

    getSuggestionValue(suggestion) {
      return suggestion.item.company_name;
    },
  },
};
</script>
